/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect, useState } from 'react';
import { Router, Switch, Route } from 'react-router-dom';
import { useAuthUser, useAuthAccountId } from '@nbx/frontend-helpers/subscribe';
import Markets from 'routes/Markets';
import Trade from 'routes/Trade';
import { NBXMarkets, NBXUsers, NBXAccounts } from 'services';
import { updatePreviewTakerFee } from 'helpers/hooks/takerFee';
import { ConfigProvider } from '@nbx/config';
import { CommonContextProvider } from '@nbx/providers';
import { LocalCurrencyProvider } from './providers';
import './i18n';

const microapps = window.MICROFRONTENDS_CONFIG;

function App() {
  const user = useAuthUser();
  const accountId = useAuthAccountId();
  const [configured, setConfigured] = useState(false);

  useEffect(() => {
    window
      .GET_API_CONFIG()
      .then(config => {
        NBXMarkets.init(config.api.markets);
        NBXUsers.init(config.api.users);
        NBXAccounts.init(config.api.accounts);
        updatePreviewTakerFee(config.markets.previewTradingFee);
        setConfigured(true);
        const spinner = document.querySelector('#microfrontend_hook > .spinner');
        if (spinner) {
          spinner.parentNode.removeChild(spinner);
        }
      })
      .catch(error => {
        throw new Error('Error loading configuration file: ', error);
      });
  }, []);

  if (!configured) return null;

  return (
    <ConfigProvider defaults={{ markets_price_alerts_feature_flag: false }}>
      <CommonContextProvider>
        <LocalCurrencyProvider>
          <Router history={window.HISTORY}>
            <Switch>
              <Route
                path={window.GET_LOCALE_PATHS(microapps?.routes?.markets?.path)}
                exact
                component={props => <Markets {...props} user={user} accountId={accountId} />}
              />
              <Route
                path={window.GET_LOCALE_PATHS(microapps?.routes?.trading?.path)}
                component={props => <Trade {...props} user={user} accountId={accountId} />}
              />
            </Switch>
          </Router>
        </LocalCurrencyProvider>
      </CommonContextProvider>
    </ConfigProvider>
  );
}

export default App;
